<svg width="480" height="108" viewBox="0 0 480 108" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 108C17.3191 101.071 65.9121 96.1805 127.446 96.1805C188.98 96.1805 281.125 104.638 336.184 108C391.242 111.362 442.061 108 480 101.071V0H0V108Z" fill="#E5F7E0"/>
</svg>
